import React from 'react';

import { toast } from 'react-toastify';
import { sendMosruIndication } from '../../../api/api';
import useThrottle from '../../../utils/use-throttle';
import IntegrationButton from './IntegrationButton';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

const MosruIndicationButton = ({ deviceId }) => {
  const handleErrors = (error) => {
    if (error && error?.length > 0) {
      const errors = error?.map((item) => item.error).join('\n');
      toast.error(errors, { hideProgressBar: true, autoClose: false });
    }
  };

  const sendIndicationToMosru = useThrottle(async () => {
    await sendMosruIndication(deviceId, () => toast.success('Показания успешно переданы в Mos.ru!', { hideProgressBar: true, autoClose: false }), handleErrors);
  }, 500);

  return <IntegrationButton Icon={WarningAmberIcon} handleClick={sendIndicationToMosru} label={'Принудительная отправка'} />;
};

export default MosruIndicationButton;
